import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { createWhatsAppSMSProvider } from './auth/whatsapp-provider';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyB5iBTjS3w-POPzBTlWSEyvph2X43NET2I",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "namat-clinic.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "namat-clinic",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "namat-clinic.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "392594971153",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:392594971153:web:334d410c74ac8f84106fb0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Configure custom SMS provider for phone authentication
// This will use WhatsApp instead of Firebase's SMS service
export function configureWhatsAppSMSProvider(language: 'en' | 'ar' = 'en') {
  console.log('🔧 [Firebase Config] Configuring WhatsApp SMS provider for language:', language);
  
  // Set the custom SMS provider
  // Note: This is a simplified approach. In a production environment,
  // you might need to use Firebase Functions or a more complex setup
  // to fully replace the SMS provider
  
  // For now, we'll use the custom provider in our phone auth flow
  const smsProvider = createWhatsAppSMSProvider(app, language);
  
  // Store the provider globally so it can be accessed by the phone auth flow
  (window as any).whatsappSMSProvider = smsProvider;
  
  console.log('✅ [Firebase Config] WhatsApp SMS provider configured successfully');
}

// TODO: migrate to FirestoreSettings.cache in the future to avoid deprecation warning

export default app;